import React, {Component} from "react"

class Spinner extends Component {

  render() {
    const spinner = this.props.show?
      <div className="sk-spinner sk-spinner-three-bounce">
        <div className="sk-bounce1"></div>
        <div className="sk-bounce2"></div>
        <div className="sk-bounce3"></div>
      </div> : null
    return spinner
  }
}

export default Spinner



// WEBPACK FOOTER //
// ./src/components/Spinner.js